import styled from 'styled-components';
import theme from '@adsk/alloy-react-theme';

const ProductLinksBar = styled.div({
  width: '100%',
  height: '48px',
  backgroundColor: theme.colors.white,
  borderBottom: `1px solid ${theme.colors.charcoal200}`,
  marginBottom: 32,
  padding: '0px 48px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export default ProductLinksBar;
